import { render, staticRenderFns } from "./HoverButton.vue?vue&type=template&id=15b65f30&scoped=true"
import script from "./HoverButton.vue?vue&type=script&lang=ts"
export * from "./HoverButton.vue?vue&type=script&lang=ts"
import style0 from "./HoverButton.vue?vue&type=style&index=0&id=15b65f30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b65f30",
  null
  
)

export default component.exports